import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@src/components/Card';
import { CODE_TASK, TASK_REWARD_CODE } from '@src/constants/referral';
import { TASK_TYPE } from '@src/constants/tasks';
import apis from '@src/apis';
import actions from '@src/redux/actions';
import ReferralIntro from './ReferralIntro';
import ReferralCode from './ReferralCode';
import { StyledReferralContainer } from './index.style';
import ReferralStats from './ReferralStats';
import Rules from './Rules';
import StatBanner from './ReferralStats/StatBanner';
import RewardTasks from './RewardTasks';
import RewardProgressTracker from './RewardProgressTracker';

const ReferralContainer = () => {
  const dispatch = useDispatch();

  const [maxRewardCharacter, setMaxRewardCharacter] = useState(0);
  const [redeemedCharacters, setRedeemedCharacters] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([]);

  const { user } = useSelector((state) => state.auth);
  const { referral } = user;
  useEffect(() => {
    const fetchTasks = async () => {
      setLoading(true);
      const data = await apis.tasks.getTasks(TASK_TYPE.REFERRAL);
      setTasks(data || []);
      setLoading(false);
    };
    fetchTasks();
  }, [referral?.referrerId, user?.packageCode]);

  useEffect(() => {
    const fetchReferralRevenue = async () => {
      const response = await apis.referral.getReferral();
      const { totalRevenue = 0, refereeFirstPaidOrderCount = 0 } =
        response.result;
      dispatch(
        actions.auth.updateReferralRevenue({
          totalRevenue,
          refereeFirstPaidOrderCount,
        }),
      );
    };
    fetchReferralRevenue();
  }, []);

  const referrerTask = useMemo(
    () =>
      tasks?.find((task) => task?.code === CODE_TASK.REFEREE_FIRST_PAID_ORDER),
    [tasks?.length],
  );

  const referrerPoints = useMemo(
    () =>
      referrerTask?.rewards
        ?.filter(
          (reward) => reward?.details?.target === TASK_REWARD_CODE.REFERRER,
        )
        ?.reduce((acc, reward) => acc + reward?.details?.amount, 0),
    [referrerTask?.rewards?.length],
  );

  const refereePoints = useMemo(
    () =>
      referrerTask?.rewards
        ?.filter(
          (reward) => reward?.details?.target === TASK_REWARD_CODE.REFEREE,
        )
        ?.reduce((acc, reward) => acc + reward?.details?.amount, 0),
    [referrerTask?.rewards?.length],
  );

  return (
    <StyledReferralContainer>
      <Card flexDirection="column" className="referral-card">
        <ReferralIntro />
        <ReferralCode />
        <StatBanner
          maxRewardCharacter={maxRewardCharacter}
          redeemedCharacters={redeemedCharacters}
        />
        <ReferralStats
          setMaxRewardCharacter={setMaxRewardCharacter}
          setRedeemedCharacters={setRedeemedCharacters}
        />
        <RewardTasks tasks={tasks} loading={loading} />
        <RewardProgressTracker />
        <Rules
          referrerPointsTask={referrerPoints}
          refereePointsTask={refereePoints}
        />
      </Card>
    </StyledReferralContainer>
  );
};
export default ReferralContainer;
